<template>
  <v-footer absolute class="bg-secondary">
    <v-row
    align="center"
    class=" ma-auto"
    style="width:100%; max-width:1200px;"
    >
      <v-col cols="6"  class="d-flex justify-center">
        <div v-ripple>
          <span class="snsbutton fade">
            <!-- twitter -->
            <a
              href="http://twitter.com/share?&url=http://d-mebius.com/buraicomplete/"
              rel="nofollow"
            >
              <picture>
                <souce
                  srcset="../assets/icon_twitter.webp"
                  type="image/webp"
                  width="64"
                  height="64"
                />
                <img
                  src="../assets/icon_twitter.png"
                  alt="ツイート"
                  width="64"
                  height="64"
                />
              </picture>
            </a>
          </span>
        </div>
      </v-col>
      <v-col cols="6" class="d-flex justify-center">
        <div v-ripple>
          <span class="snsbutton">
            <!-- facebook -->
            <a
              href="http://www.facebook.com/share.php?u=http://d-mebius.com/buraicomplete/"
              onclick="window.open(encodeURI(decodeURI(this.href)), 'FBwindow', 'width=554, height=470, menubar=no, toolbar=no, scrollbars=yes'); return false;"
              rel="nofollow"
            >
              <picture>
                <souce
                  srcset="../assets/icon_fb.webp"
                  type="image/webp"
                  width="64"
                  height="64"
                />
                <img src="../assets/icon_fb.png" width="64" height="64" />
              </picture>
            </a>
          </span>
        </div>
      </v-col>

      <!-- end .sns -->
    </v-row>
    <v-row
      align="center"
    >
      <v-col cols="6" md="3"  class="d-flex justify-center">
        <div>
          <picture class="ma-5">
            <source
              srcset="../assets/icon_switch.webp"
              type="image/webp"
              width="64"
              height="64"
            />
            <img src="../assets/icon_switch.png" width="64" height="64" />
          </picture>
        </div>
      </v-col>
      <v-col cols="6" md="3" class="d-flex justify-center">
        <div v-ripple>
          <a href="http://d-mebius.com/">
            <picture class="ma-5">
              <source
                srcset="../assets/logo_mebius.webp"
                type="image/webp"
                width="175"
                height="43"
              />
              <img src="../assets/logo_mebius.png" width="175" height="43" />
            </picture>
          </a>
        </div>
      </v-col>

      <v-col cols="6" md="3" class="d-flex justify-center">
        <div v-ripple>
          <a href="https://takiya.info/">
            <picture class="ma-5">
              <source
                srcset="../assets/logo_shanon.webp"
                type="image/webp"
                width="140"
                height="62"
              />
              <img src="../assets/logo_shanon.png" />
            </picture>
          </a>
        </div>
      </v-col>
      <v-col cols="6" md="3" class="d-flex justify-center">
        <div v-ripple>
          <a href="https://www.althi.co.jp/">
              <img src="../assets/logo_alti.png"               
                height="62"/>
          </a>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="copyright">
          <div class="ma-auto text-center">
            <p>
              &copy;althi Inc. &copy;飯島多紀哉. &copy;Shannon. &copy;mebius.<br/> &copy;2025 MSX Licensing Corporation All Rights Reserved.
'MSX' is a trademark of the MSX Licensing Corporation.
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<style scoped>
  footer {
    width: 100%;
    display: block;
    position: relative;
    padding-top: 30px;
  }
</style>
